import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `CopiaSeguridad`, method: 'GET', body: null, token: token})
}
